import type { SportBetsFilters } from "store/players/list/slice";

export function sportHistoryFilters(
  filters: Partial<SportBetsFilters>,
): Partial<SportBetsFilters> {
  const result = Object.fromEntries(
    Object.entries(filters).filter(([, value]) => value !== ""),
  ) as Partial<SportBetsFilters>;
  if (result.action === "cash_out") {
    result.action = "refund";
    result.betslipStatus = "cash_out";
  } else if (result.action === "refund" && !result.betslipStatus) {
    result.betslipStatus = "refund";
  }
  return result;
}
